import image1 from "../assets/merdan-bogucanin.png";
import image2 from "../assets/atleta.png";
import image3 from "../assets/tarik-ahmetovic.png";

export const testimonialsData = [
  {
    image: image1,
    review:
      "Odabrao sam pravi klub i program u Sandžak Top Tim-u, dok je uspeh na takmičenjima bio nezaobilazni deo ovog putovanja!",
    name: "MERDAN BOGUĆANIN",
    status: "PREDUZETNIK",
  },
  {
    image: image2,
    review:
      "Uz iskusne trenere sam za kratak vremenski period ostvario rezultate koji me motivisali na dalji rad u cilju napretka.",
    name: "MEDIN KONICANIN",
    status: "SREDNJOŠKOLAC",
  },
  {
    image: image3,
    review:
      "Svaki početak je težak, ali ga pravi ljudi čine zanimljivim, a konstantan razvoj i postignuća ga čine inspirativnim.",
    name: "TARIK AHMETOVIĆ",
    status: "TRGOVAC",
  },
];
